import axios from 'axios'
import config from './config'
import store from '../store/index'
import methods from './method'
import {
    message,
    Modal
} from 'ant-design-vue';

import md5 from 'js-md5';


//请求的api
let loginOutStatus = true

let numRequest = {}
// 请求拦截器
axios.interceptors.request.use(function (requst) {
    if (requst.headers.loading_flag) {
        numRequest[requst.url] = numRequest[requst.url] ? numRequest[requst.url] + 1 : 1
    }
    delete requst.headers.loading_flag
    if(Object.keys(numRequest).length > 0){
        store.state.loading_state = true;
    }
    return requst;
}, function (error) {
});
// 响应拦截器
axios.interceptors.response.use(function (response) {
    const r_config = response.config
    if(numRequest[r_config.url]){
        if(numRequest[r_config.url] > 1){
            numRequest[r_config.url] --
        }else{
            delete numRequest[r_config.url]
        }
    }
    if(Object.keys(numRequest).length == 0){
        store.state.loading_state = false;
    }
    return response;
}, function (error) {
    const e_config = error.config
    if(numRequest[e_config.url]){
        if(numRequest[e_config.url] > 1){
            numRequest[e_config.url] --
        }else{
            delete numRequest[e_config.url]
        }
    }
    if(Object.keys(numRequest).length == 0){
        store.state.loading_state = false;
    }
});

function req({
    url = '',
    data = {},
    type = 'post',
    loading = true,
    loading_msg = '数据加载中...',
    toast = false,
    toastTime = 2,
    mode = 'api',
    errToast = true,
    repeat = false, //是否允许重复请求
}) {
    if (loading) {
        store.state.loading_text = loading_msg;
    }

    return new Promise((resolve, reject) => {

        const current_api_url = url

        if (process.env.NODE_ENV === 'development') { // 本地代理处理
            url = '/apis' + current_api_url
        } else {
            url = config.host + url;
        }
        let headers = {
            'Content-Type': 'application/json',
            //   'token': localStorage.getItem('token')
            'loading_flag': loading
        }
        headers.token = localStorage.getItem('token')
        if (mode == 'upload') {
            headers['content-type'] = 'multipart/form-data';
            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key]);
            }
            data = form_data;
        } else {
            if (window.location.href.indexOf('/echarts') != -1) {
                let obj = methods.urlParamsToObject(window.location.href)
                data = Object.assign(obj, data)
            }

            //传入时间，生成签名（签名传入header头部）===============公共处理=============
            let sign_time = new Date().getTime() //获取当前时间戳
            data.sign_time = parseInt(parseInt(sign_time) / 1000)
            let h_name = config.head_name //签名指定参数-前后台一至
            headers.sign = md5(JSON.stringify(data).trim() + h_name).trim()
            // ========================================================
        }


        axios({
            method: type,
            url: url,
            headers,
            data: data,
        }).then(res => {
            //处理返回数据
            res = res.data
            if (res.code == 1) {
                resolve(res.data)
                if (toast) {
                    message.success(res.info || res.msg, toastTime)
                }
            } else if (res.code == -2) {
                localStorage.removeItem('token')
                if (loginOutStatus) {
                    loginOutStatus = false
                    Modal.warning({
                        title: '温馨提示',
                        content: '账号已失效，请重新登录~',
                        okText: '去登录',

                        onOk() {
                            loginOutStatus = true
                            location.href = process.env.BASE_URL + 'login'
                        }
                    });
                }
            } else if (res.code == 0) {
                if (errToast) {
                    message.error(res.info || res.msg, toastTime)
                }
                reject(res)
            }
        }).catch(e => {
            // Toast("网络错误，请稍后重试")
            reject(e)
        })
    })


}

export default req;